import { installGalleryImages } from "@/mocks/serviceInstalacionData";

export default function InstallGallery() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Galer&iacute;a
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Nuestras Instalaciones
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {installGalleryImages.map((img, i) => (
            <div
              key={i}
              className="reveal relative aspect-[4/3] rounded-lg overflow-hidden group"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[#0087a4]/0 group-hover:bg-[#0087a4]/20 transition-colors duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}